<template>
  <v-container fluid>
    <v-btn
      :to="{ name: 'admin.index' }"
      elevation="0"
      tile
      icon
    >
      <v-icon size="20">mdi-arrow-left</v-icon>
    </v-btn>

    <v-divider class="mb-3 mt-1"></v-divider>

    <v-row>
      <v-col class="py-0" cols="3">
        <v-form>
          <h3 class="body-1 mb-4">Business Scope</h3>
          <v-text-field
            v-model="scope.name"
            label="Name"
            :error-messages="errors.Name"
            solo
            dense
          ></v-text-field>

          <v-select
            v-model="scope.system"
            label="System"
            :items="systems"
            :error-messages="errors.System"
            solo
            dense
          ></v-select>

          <div class="text-right">
            <v-btn
              type="submit"
              color="primary"
              @click.prevent="saveScope"
              :disabled="disable"
              small
            >
              Save
            </v-btn>
          </div>
        </v-form>
      </v-col>

      <v-col class="py-0" cols="3">
        <v-form>
          <h3 class="body-1 mb-4">Scopes (organization)</h3>
          <p class="caption grey--text" v-if="!editing">Create a business scope first.</p>
          <app-setupform
            type="Scope"
            :show="!!editing"
            :scope="editing"
            @select="select"
            @delete="unselect"
            :selected="selectedScope"
          />
        </v-form>
      </v-col>

      <v-col class="py-0" cols="3">
        <h3 class="body-1 mb-4">
          Tracking Params
          <span v-if="selectedScope.guid">- {{ _.get(selectedScope, 'name') }}</span>
        </h3>
        <p class="caption grey--text" v-if="!editing">Create a business scope first.</p>
        <p class="caption grey--text" v-if="editing && !selectedScope.guid">
          Select a scope to add params.
        </p>
        <app-setupform
          type="Param"
          :show="!!editing && !!selectedScope.guid"
          :scope="editing"
          :selected="selectedScope"
        />
      </v-col>

      <v-col class="py-0" cols="3">
        <h3 class="body-1 mb-4">Icons</h3>
        <p class="caption grey--text" v-if="!editing">Create a business scope first.</p>
        <app-setupform
          type="Icon"
          :show="!!editing"
          :scope="editing"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Scope } from '@/api';
import { error } from '@/utils';
import store from '@/store';

export default {
  name: 'app-setup-create',
  async beforeRouteEnter(to, from, next) {
    if (!to.params.setup) next();
    else {
      store.commit('START_LOADING');
      /* eslint-disable */
      try {
        const { data } = await Scope.find(to.params.setup);
        next((vm) => { vm.scope = data; });
      } catch (err) {
        next();
      }
      /* eslint-enable */
      store.commit('END_LOADING');
    }
  },
  data() {
    return {
      scope: { },
      errors: { },
      disable: false,
      systems: [],
      selectedScope: { },
      selectedParam: { },
    };
  },
  computed: {
    editing() {
      return this.$route.params.setup;
    },
    method() {
      return this.editing ? 'update' : 'create';
    },
  },
  methods: {
    async saveScope() {
      this.errors = {};
      this.disable = true;

      this.$store.commit('START_LOADING');
      try {
        const { data } = await Scope[this.method](this.scope);
        if (!this.editing) {
          this.$router.push({ name: 'setup.edit', params: { setup: data.guid } });
        } else {
          this.$router.push({ name: 'business-scope.index' });
        }
      } catch (err) {
        this.errors = error(err);
      }
      this.disable = false;
      this.$store.commit('END_LOADING');
    },
    select(scope) {
      this.selectedScope = scope;
    },
    unselect() {
      this.selectedScope = { };
    },
  },
  async created() {
    const { data } = await Scope.systems();
    this.systems = data.map(s => ({ text: s, value: s }));
  },
};
</script>
